import { byMat, isChecked, isPryamik, isPryamikspn, round } from '@/includes/utils';
import resolveGoodsData from '@/includes/resolveGoodsData';
import { ALERT_MSG, KeysThatCanBeDeleted } from '@shared/data';
import { getFlangeNameForFrameXls } from '@shared/utils';
import LocalCart from '@/class/LocalCart';
import { calcMontageTotals } from '@/includes/helpers';
const DUCT_ERRORS = [
    'Данные [m, s, e] не определены!',
    'Не хватает данных в elements[s][e]',
    `Не удалось найти поле 'thickness' в store[airDuct]`,
    'Не хватает данных в materialCost[m][thickness]',
    'Не хватает данных в flangeCost[m][fv]',
    `Не удалось забрать поле 'Шина' или 'Уголок' из flangeCost[m][fv]`,
    `Не удалось забрать поле 'прямик' или 'фасонка' из away`,
    `Не удалось забрать значение 'LParameter' по индексу - `,
];
const descrExcludePattern = ['--', '---', '----'];
class CalcBuilder {
    constructor(fields, goodsSelects, elements) {
        this.fields = fields;
        this.product = this.fields.goods.value;
        this.goodsSelects = goodsSelects;
        this.elements = elements;
    }
    build(isAirDuct, elementKey) {
        try {
            return isAirDuct
                ? this.buildAirDuctItem(elementKey)
                : { isList: false, value: this.buildProductItem() };
        }
        catch (e) {
            alert(e.message);
            return null;
        }
    }
    clearOfEmptyData(str) {
        const map = KeysThatCanBeDeleted.reduce((acc, it) => {
            const pos = str.indexOf(it);
            if (pos === -1)
                return acc;
            else {
                acc[it] = pos;
                return acc;
            }
        }, {});
        const list = [];
        Object.keys(map).sort((a, b) => map[a] - map[b]).forEach((it, i, arr) => {
            const start = str.indexOf(it);
            if (i === 0)
                list.push(str.substring(0, str.indexOf(it)));
            const next = arr === null || arr === void 0 ? void 0 : arr[i + 1];
            const finish = next !== undefined && str.includes(next) ? str.indexOf(next) : str.length;
            const slice = str.substring(start, finish);
            if (slice.includes('-')) {
                const split = slice.split('-');
                if (!(split.at(-1) || '').trim())
                    return;
                list.push(slice);
            }
            else if (slice[arr[i].length] !== ' ') {
                list.push(slice);
            }
        });
        return list.join('').replace(' - ', ' ').trim();
    }
    clearShortDescr(descr) {
        return descr.split(' ').filter(it => {
            return it.trim() !== '' && it.split('=')[1] !== '';
        }).join(' ');
    }
    buildAirDuctItem(elementKey) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const [m, s, e] = this.getAirDuctFields();
        const framesInfoForExcel = [];
        const info = (_b = (_a = window === null || window === void 0 ? void 0 : window[elementKey]) === null || _a === void 0 ? void 0 : _a[s]) === null || _b === void 0 ? void 0 : _b[e];
        if (!info) {
            console.error(DUCT_ERRORS[1]);
            throw new Error(ALERT_MSG.ERROR);
        }
        const values = this.elements.getValues(info.params);
        for (let i = 0; i < values.length; i++) {
            if (Number.isNaN(values[i]) || +values[i] <= 0) {
                const err = `Параметр ${(_c = info.params) === null || _c === void 0 ? void 0 : _c[i]} задан не верно. Попробуйте исправить значение`;
                throw new Error(err);
            }
        }
        const count = +this.elements.getValue('count');
        if (Number.isNaN(count) || count <= 0) {
            throw new Error(ALERT_MSG.NO_COUNT);
        }
        const Smm2 = info.formula(...values);
        const Sm2 = Smm2 / 1000000;
        const thickness = this.elements.getValue('thickness');
        const materialCost = (_e = (_d = window === null || window === void 0 ? void 0 : window.calcZV_materialCost) === null || _d === void 0 ? void 0 : _d[m]) === null || _e === void 0 ? void 0 : _e[thickness];
        if (!materialCost) {
            console.error(DUCT_ERRORS[3]);
            throw new Error(ALERT_MSG.ERROR);
        }
        const density = this.elements.getSafeValue('plotnost1');
        const ral = this.elements.getSafeValue('ral1');
        const production = ((_f = window === null || window === void 0 ? void 0 : window.calcData) === null || _f === void 0 ? void 0 : _f.productionCost) || 190;
        const away = CalcBuilder.calculateAway(info, values, e);
        const elemPrice = Sm2 * (materialCost * away + production);
        function getZeroValues() {
            const withZero = [
                'price',
                'tireLength',
                'angleCount',
                'tire2Len',
                'tire3Len',
                'angle2Count',
                'angle3Count',
            ];
            const info = {};
            for (const key of withZero)
                info[key] = 0;
            return info;
        }
        const flangesInfo = info.flanges !== undefined
            ? this.elements.calculateFlangesCost(info.flanges(...values))
            : getZeroValues();
        const flangesCost = flangesInfo.price;
        const ductCoef = +(((_k = (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.calcZV_ductsAdditionals) === null || _g === void 0 ? void 0 : _g[m]) === null || _h === void 0 ? void 0 : _h[s]) === null || _j === void 0 ? void 0 : _j[e]) === null || _k === void 0 ? void 0 : _k[thickness]) || 0);
        const densityCost = density !== null ? (+(((_m = (_l = window === null || window === void 0 ? void 0 : window.calcZV_surchargeCost) === null || _l === void 0 ? void 0 : _l.density) === null || _m === void 0 ? void 0 : _m[density]) || 0)) : 0;
        const ralCost = (ral !== null && !descrExcludePattern.includes(ral)) ? Sm2 * (((_o = window === null || window === void 0 ? void 0 : window.calcZV_surchargeCost) === null || _o === void 0 ? void 0 : _o.ral) || 0) : 0;
        const price = round(((elemPrice + flangesCost) * ductCoef) + densityCost + ralCost, 2);
        if (Number.isNaN(price)) {
            throw new Error(ALERT_MSG.NO_CALCULATE);
        }
        const elementAsString = (_r = (_q = (_p = window === null || window === void 0 ? void 0 : window[elementKey]) === null || _p === void 0 ? void 0 : _p[s]) === null || _q === void 0 ? void 0 : _q[e]) === null || _r === void 0 ? void 0 : _r.text;
        const descriptionFields = this.elements.getFieldsDescription();
        const otherFields = descriptionFields.filter(it => {
            return !descrExcludePattern.includes(it.split('=').at(1));
        }).join(', ');
        const getFilteredStandardValues = () => {
            const values = this.elements.getValues((info === null || info === void 0 ? void 0 : info.standardNameParams) || []);
            return values.map(it => !descrExcludePattern.includes(String(it)) ? it : '');
        };
        const description = (info === null || info === void 0 ? void 0 : info.getDescription) !== undefined
            ? (() => {
                const sv = getFilteredStandardValues();
                const cl = info.getDescription(...sv);
                const mt = cl.replace('%material', byMat(m));
                return this.clearShortDescr(mt);
            })()
            : `${this.product}, ${m}, ${s}, ${elementAsString} (${otherFields})`;
        const standardName = (info === null || info === void 0 ? void 0 : info.standardName) === undefined
            ? description
            : (() => {
                const sv = getFilteredStandardValues();
                const sn = info.standardName(...sv);
                const cl = this.clearOfEmptyData(sn);
                return cl.replace('%material', byMat(m));
            })();
        let excelFields = [standardName];
        let supplierData = [standardName];
        const getStandardValues = () => {
            return this.elements.getValues(info.standardNameParams);
        };
        if (info.standardNameParams) {
            if ((info === null || info === void 0 ? void 0 : info.excelFields) !== undefined) {
                excelFields = info.excelFields(...getStandardValues());
                if (excelFields.length < 1)
                    excelFields = ['?'];
                excelFields.splice(2, 0, byMat(m));
            }
            if (typeof (info === null || info === void 0 ? void 0 : info.supplierData) === 'function') {
                supplierData = info.supplierData(...getStandardValues());
            }
            if ((info === null || info === void 0 ? void 0 : info.flanges) !== undefined && (info === null || info === void 0 ? void 0 : info.flangeTypes) !== undefined) {
                const theFlangeTypes = info.flangeTypes(...getStandardValues());
                const theFlangeSizes = info.flanges(...values);
                for (let i = 0; i < theFlangeTypes.length && i < theFlangeSizes.length; i++) {
                    const flangeType = getFlangeNameForFrameXls(theFlangeTypes[i]);
                    if (flangeType === '')
                        continue;
                    const newFrameInfo = {
                        material: byMat(m),
                        flangeType: flangeType,
                        size: theFlangeSizes[i],
                    };
                    framesInfoForExcel.push(newFrameInfo);
                }
            }
        }
        const list = [{
                standardName, thickness,
                excelFields, framesInfoForExcel,
                description, count, supplierData,
                square: Sm2.toFixed(3),
                price: price.toFixed(2),
                tireLength: flangesInfo.tireLength * count,
                angleCount: flangesInfo.angleCount * count,
                tire2Len: flangesInfo.tire2Len * count,
                tire3Len: flangesInfo.tire3Len * count,
                angle2Count: flangesInfo.angle2Count * count,
                angle3Count: flangesInfo.angle3Count * count,
                type: 'airduct',
            }];
        const additional = [
            {
                logic: {
                    list: [
                        isChecked('#calcZV__add_fasteners', true),
                        this.fields.section.value === 'Прямоугольное',
                    ],
                    rule: 'every',
                },
                builder: () => {
                    var _a;
                    return (_a = this.buildAutoFasteners(framesInfoForExcel, count)) !== null && _a !== void 0 ? _a : [];
                },
            },
            {
                logic: {
                    list: [
                        isChecked('#calcZV__autowork', true),
                        !LocalCart.list.find(it => it.type === 'montage'),
                    ],
                    rule: 'every',
                },
                builder: () => {
                    const item = this.buildMontageItem(list[0]);
                    return item ? [item] : [];
                },
            },
        ];
        for (const { logic, builder } of additional) {
            const logicRuleExit = logic.rule === 'every'
                ? logic.list.some(it => !it)
                : logic.list.every(it => !it);
            if (logicRuleExit)
                continue;
            list.push(...builder());
        }
        return list.length === 1
            ? { isList: false, value: list[0] }
            : { isList: true, value: list };
    }
    buildProductItem(prdct, prms, cnt) {
        var _a, _b, _c;
        const product = prdct || this.product;
        const params = prms || this.getProductParams();
        const resolver = resolveGoodsData(product, params);
        const excelFields = [];
        let current = 0;
        for (const [data] of resolver) {
            if (data === undefined)
                continue;
            if (typeof data !== 'object')
                current = +data;
            else if ('excel' in data)
                excelFields.push(data.excel);
        }
        const count = cnt || +(((_a = this.goodsSelects.at(-1)) === null || _a === void 0 ? void 0 : _a.value) || NaN);
        if (Number.isNaN(count) || count <= 0) {
            const msg = 'Параметр "Количество" задан не верно. Попробуйте исправить значение';
            throw new Error(msg);
        }
        const otherFields = params.join(', ');
        const price = current;
        let description = `${product} ${otherFields}`;
        let flangeExcelField = '';
        if (params.length > 0) {
            flangeExcelField = params.at(-1);
        }
        if (excelFields.length > 0) {
            const resultExcelFields = [excelFields.join(',')];
            description = `${resultExcelFields} - ${flangeExcelField}`;
            excelFields[1] = (_b = excelFields[1]) !== null && _b !== void 0 ? _b : '';
            excelFields[2] = (_c = excelFields[2]) !== null && _c !== void 0 ? _c : '';
            excelFields[3] = flangeExcelField;
        }
        const zeroKeys = [
            'tireLength',
            'angleCount',
            'tire2Len',
            'tire3Len',
            'angle2Count',
            'angle3Count',
        ];
        const getZeroValues = () => {
            return zeroKeys.reduce((acc, key) => {
                acc[key] = 0;
                return acc;
            }, {});
        };
        return Object.assign(Object.assign({ description,
            excelFields,
            count, standardName: description, supplierData: undefined, square: '—', price: price.toFixed(2), thickness: '0', framesInfoForExcel: [] }, getZeroValues()), { type: 'goods' });
    }
    buildAutoFasteners(flanges, count) {
        const calc = () => (count * 2) - (count - 1);
        const formula = (data) => Math.min(...data) * (count - 1);
        const sum = (data) => data.reduce((qty, it) => qty + it, 0);
        const BOLTS = 4;
        const entity = flanges.reduce((acc, it) => {
            var _a, _b;
            if (!['20', '30'].includes(it.flangeType))
                return acc;
            acc.bolts += BOLTS;
            acc.clips.push(((_a = it.size) === null || _a === void 0 ? void 0 : _a.reduce((c, s) => {
                if (s < 500)
                    return c;
                else if (s >= 500 && s < 800)
                    return c + 2;
                else
                    return c + 4;
            }, 0)) || 0);
            acc.tape.push((((_b = it.size) === null || _b === void 0 ? void 0 : _b.reduce((c, s) => c + s, 0)) || 0) * 2);
            return acc;
        }, { clips: [], bolts: 0, tape: [] });
        const qtyBolts = count >= 2 && flanges.length >= 2
            ? flanges.length === 3 ? (BOLTS * calc()) + (BOLTS * count) : BOLTS * calc()
            : entity.bolts * count;
        const perimeter = sum(entity.tape) * count;
        const totalClips = sum(entity.clips) * count;
        const qtyTape = Math.ceil((count >= 2 && entity.tape.length >= 2
            ? perimeter - formula(entity.tape) : perimeter) / 5000);
        const smartClips = [...new Set(entity.clips)].length !== entity.clips.length
            ? entity.clips[0] * calc() + (flanges.length === 3 ? sum(entity.clips.slice(2)) * count : 0)
            : (count === 1 || entity.clips.length === 1)
                ? totalClips : totalClips - formula(entity.clips);
        if (![qtyBolts, qtyTape, smartClips].some(Boolean))
            return null;
        const products = [
            { params: ['Болт DIN 933', 'М8х30'], count: qtyBolts },
            { params: ['Гайка DIN 934', 'М8'], count: qtyBolts },
            { params: ['Скоба (жимник)', 'м8х3'], count: smartClips },
            { params: ['Лента уплотнительная', 'RDGE 10*5 (10м)'], count: qtyTape },
        ];
        return products.reduce((acc, { params, count }) => {
            if (count > 0) {
                const props = [
                    'Крепёж и материалы', ['Для вентиляции', ...params],
                ];
                acc.push(this.buildProductItem(...props, count));
            }
            return acc;
        }, []);
    }
    buildMontageItem(obj) {
        if (!obj)
            return null;
        const cart = [...LocalCart.list, obj];
        const montage = cart.find(it => it.type === 'montage');
        if (montage)
            return null;
        const { count, text, base, square, totalPrice } = calcMontageTotals(cart);
        return {
            count: count,
            price: base.toFixed(2),
            angleCount: 0,
            angle2Count: 0,
            angle3Count: 0,
            description: text,
            tireLength: 0,
            tire2Len: 0,
            tire3Len: 0,
            square: square.toFixed(3),
            excelFields: [],
            standardName: text,
            thickness: '—',
            framesInfoForExcel: [],
            type: 'montage',
            totalPrice: totalPrice.toFixed(2),
            supplierData: undefined,
        };
    }
    getProductParams() {
        const list = this.goodsSelects.slice(0, -1);
        return Object.values(list).map(it => it.value);
    }
    getAirDuctFields() {
        return [
            this.fields.material.value,
            this.fields.section.value,
            this.fields.element.value,
        ];
    }
    static getLParamAndBothAway(params, values) {
        var _a, _b;
        const away1 = (_a = window.calcZV_away) === null || _a === void 0 ? void 0 : _a['прямик'];
        const away2 = (_b = window.calcZV_away) === null || _b === void 0 ? void 0 : _b['фасонка'];
        if (away1 === undefined || away2 === undefined) {
            console.error(DUCT_ERRORS[6]);
            throw new Error(ALERT_MSG.ERROR);
        }
        let index = -1;
        for (let i = 0; i < params.length; i++) {
            if (params[i] === 'L')
                index = i;
        }
        if (index === -1) {
            const msg = 'Параметр L не найден. Передайте информацию в организацию ILYSAN';
            throw new Error(msg);
        }
        const LParameter = values === null || values === void 0 ? void 0 : values[index];
        if (LParameter === undefined) {
            console.error(`${DUCT_ERRORS[7]} ${index}`);
            throw new Error(ALERT_MSG.ERROR);
        }
        return {
            away1,
            away2,
            LParameter,
        };
    }
    static calculateAway(info, values, element) {
        var _a;
        const away = (_a = window.calcZV_away) === null || _a === void 0 ? void 0 : _a['фасонка'];
        if (away === undefined)
            throw new Error('Не заполнено поле "фасонка" в коэффициентах away');
        if (!(isPryamik(element) || isPryamikspn(element)))
            return away;
        const data = this.getLParamAndBothAway(info.params, values);
        const { away1, away2 } = data;
        const LParameter = +data.LParameter;
        if (isPryamik(element)) {
            const by1250 = Math.floor(LParameter / 1250) * 1250;
            const rest1250 = LParameter - by1250;
            return (by1250 * away1 + rest1250 * away2) / LParameter;
        }
        else if (isPryamikspn(element)) {
            const by1000 = Math.floor(LParameter / 1000) * 1000;
            const rest3000 = LParameter - by1000;
            return (by1000 * away1 + rest3000 * away2) / LParameter;
        }
        return away;
    }
}
export default CalcBuilder;
